// extracted by mini-css-extract-plugin
module.exports = {"content":"Fitting_content__1icSf","submitBtn":"Fitting_submitBtn__3BSES"};